module.exports = __webpack_public_path__ + "static/media/weather-dashboard.efad3568.png";